// -- other --
import {useState,useEffect} from "react";
import {Link} from "react-router-dom";
import ImageWithBasePath from "../../core/img";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import {Toaster} from 'react-hot-toast';
import SubValue from "../subValue";
import {all_routes} from "../router/all_routes";
// -- biz9 --
import {UrlQuery} from "biz9-react-utility";
import {Log,Response_Logic} from "biz9-utility";
import {Image_Format} from "biz9-image";
import {Page_Logic,Portal_Remote_Page,Portal_Remote_Data,Portal_Type,Portal_Title,Portal_Page,Portal_Table,Portal_Url,Sub_Value_Logic,Portal_Value_Type,Sub_Value_Type} from "biz9-portal-app";
import {Data_Logic} from "biz9-data-app";
import {Message,Config} from "../../constant";
import {Field_Logic,Image,Toast_Message,Storage,App} from "../../project";

const About = () => {
    /* -- DEFINE -- *
     * --- PAGE-EDIT-FIELDS ---
     *  10 - group - image, text
     *  14 - group - image, title, sub_note
     *  17 - group - image, title, sub_note
     *  23 - group - text
     *
    */
    const query = UrlQuery();
    const [categorys,setCategorys] = useState([]);
    // -- page-edit --
    const [sub_value_edit,setSubValueEdit] = useState(Sub_Value_Logic.get_sub_value_edit(Portal_Table.PAGE,0));
    const [page,setPage] = useState(Data_Logic.get(Portal_Table.PAGE,0));
    const [sub_value_group,setSubValueGroup] = useState(Sub_Value_Logic.get_test_sub_value_group({count:50,show_value:false}));
    const [edit_mode,setEditMode] = useState(false);
   useEffect(() => {
            Toast_Message.loading(Message.LOADING);
            get_page_data();
    },[]);
   useEffect(() => {
            Toast_Message.loading(Message.LOADING);
            get_items_data();
    },[]);
       async function get_page_data() {
        // -- remote-data-response --
        let option = {get_cache:false,time_limit:10};
        const [response,data] = await Portal_Remote_Page.get(App.get_url(Portal_Url.PAGE_GET),Portal_Page.ABOUT_HOME.title_url,option);
        bind_page(data);
    };
    async function get_items_data() {
        // -- remote-data-response --
        let option = {get_cache:false,time_limit:10};
        const [response,data] = await Portal_Remote_Page.get_home_items(App.get_url(Portal_Page.HOME[Portal_Type.ITEMS_URL]),option);
        Log.w('11_data',data);
        bind_items(data);
        Toast_Message.dismiss();
    }
    async function bind_items(data) {
                // -- categorys --
                setCategorys(data[Portal_Type.CATEGORYS]);
            }

    async function bind_page(data) {
        // -- page --
        setPage(data[Portal_Type.PAGE]);
        // -- page-edit --
        setEditMode(query.get('edit_mode'));
        setSubValueEdit(Sub_Value_Logic.get_sub_value_edit(Portal_Table.PAGE,data[Portal_Type.PAGE].id));
        // -- sub-values --
        bind_sub_values(data[Portal_Type.SUB_VALUE_GROUP]);
    };
    async function bind_sub_values(data_sub_group) {
        // -- bind-sub-values --
        for(const sub_group in data_sub_group){
            if(data_sub_group[sub_group].type != Sub_Value_Type.ITEMS){
                sub_value_group[Portal_Type.SUB_VALUE_UNDER_SCORE+data_sub_group[sub_group].value_id].value = data_sub_group[sub_group].value;
            }else{
                sub_value_group[Portal_Type.SUB_VALUE_UNDER_SCORE+data_sub_group[sub_group].value_id].items = data_sub_group[sub_group].items;
            }
        }
        Storage.post_sub_value_group(sub_value_edit,data_sub_group);
    };
     async function update_sub_value(sub_value) {
        // -- page-edit-sub-values --
        if(sub_value.type != Sub_Value_Type.ITEMS){
            setSubValueGroup(sub_value_group => ({
                ...sub_value_group,
                    [Portal_Type.SUB_VALUE_UNDER_SCORE+sub_value.value_id]: {
                    ...sub_value_group[Portal_Type.SUB_VALUE_UNDER_SCORE+sub_value.value_id],
                    value: sub_value.value
                }
            }));
        }else{
            setSubValueGroup(sub_value_group => ({
                ...sub_value_group,
                    [Portal_Type.SUB_VALUE_UNDER_SCORE+sub_value.value_id]: {
                    ...sub_value_group[Portal_Type.SUB_VALUE_UNDER_SCORE+sub_value.value_id],
                    items: sub_value.items
                }
            }));
        }
    }
    const clientstay = {
        dots: false,
      infinite: true,
      speed: 2000,
      slidesToShow: 3,
      slidesToScroll: 1,
      autoplay: false,
      arrows: true,
      responsive: [
      {
breakpoint: 1200,
            settings: {
slidesToShow: 3,
            },
      },
      {
breakpoint: 1000,
            settings: {
slidesToShow: 2,
            },
      },
      {
breakpoint: 768,
            settings: {
slidesToShow: 2,
            },
      },
      {
breakpoint: 550,
            settings: {
slidesToShow: 1,
            },
      },
      {
breakpoint: 0,
            settings: {
slidesToShow: 1,
            },
      },
      ],
    };
    const popularCategorySlider  = {
dots: true,
      infinite: true,
      speed: 2000,
      slidesToShow: 5,
      slidesToScroll: 1,
      autoplay: false,
      arrows: false, // nav:false in Owl
      responsive: [
      {
breakpoint: 1200,
            settings: {
slidesToShow: 5,
            },
      },
      {
breakpoint: 1000,
            settings: {
slidesToShow: 4,
            },
      },
      {
breakpoint: 768,
            settings: {
slidesToShow: 1,
            },
      },
      {
breakpoint: 550,
            settings: {
slidesToShow: 1,
            },
      },
      {
breakpoint: 0,
            settings: {
slidesToShow: 1,
            },
      },
      ],
    };
    return (
            <>
            {/* Breadcrumb */}
            <div className="breadcrumb-bar">
            <div className="breadcrumb-img">
            <div className="breadcrumb-left">
            <ImageWithBasePath src="/assets/img/bg/breadcrump-bg-01.png" alt="img" />
            </div>
            </div>
            <div className="container">
            <div className="row">
            <div className="col-md-12 col-12">
            <nav aria-label="breadcrumb" className="page-breadcrumb">
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <Link to={all_routes.home}>Home</Link>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  {sub_value_group.sub_value_1.value}{" "}
                </li>
              </ol>
            </nav>

            <h2 className="breadcrumb-title">
            {edit_mode?Field_Logic.get_sub_value_edit_link(sub_value_edit,Sub_Value_Type.TEXT,1):""}
            {sub_value_group.sub_value_1.value}
            </h2>
            </div>
            </div>
            </div>
            <div className="breadcrumb-img">
            <div className="breadcrumb-right">
            <ImageWithBasePath src="/assets/img/bg/breadcrump-bg-02.png" alt="img" />
            </div>
            </div>
            </div>
            {/* /Breadcrumb */}
    {/* About Us */}
    <section className="about-us-section">
        <div className="container">
        <div className="row align-items-center">
        <div className="col-lg-6">

        <div className="row me-4">

        <div className="col-sm-6">
        <div className="about-inner-img">
        {edit_mode?Field_Logic.get_sub_value_edit_link(sub_value_edit,Sub_Value_Type.IMAGE,2):""}
    <ImageWithBasePath src={Image.get_url(sub_value_group.sub_value_2.value,Image_Format.ORIGINAL)} className="img-fluid" alt="IMG" />
        </div>
        </div>

        <div className="col-sm-6">
        <div className="row">
        <div className="col-sm-12">
        <div className="about-inner-img">
        {edit_mode?Field_Logic.get_sub_value_edit_link(sub_value_edit,Sub_Value_Type.IMAGE,3):""}
    <ImageWithBasePath src={Image.get_url(sub_value_group.sub_value_3.value,Image_Format.ORIGINAL)} className="img-fluid" alt="IMG" />
        </div>
        </div>
        <div className="col-sm-12">
        <div className="about-inner-img">
        {edit_mode?Field_Logic.get_sub_value_edit_link(sub_value_edit,Sub_Value_Type.IMAGE,4):""}
    <ImageWithBasePath src={Image.get_url(sub_value_group.sub_value_4.value,Image_Format.ORIGINAL)} className="img-fluid" alt="IMG" />
        </div>
        </div>
        </div>
        </div>
        </div>
        </div>
        <div className="col-lg-6">
        <div className="about-us-info">
        <div className="about-us-head">
        <h6>
            {edit_mode?Field_Logic.get_sub_value_edit_link(sub_value_edit,Sub_Value_Type.TEXT,5):""}
            {sub_value_group.sub_value_5.value}
    </h6>
        <h2>
            {edit_mode?Field_Logic.get_sub_value_edit_link(sub_value_edit,Sub_Value_Type.TEXT,6):""}
            {sub_value_group.sub_value_6.value}
    </h2>
        <p>
            {edit_mode?Field_Logic.get_sub_value_edit_link(sub_value_edit,Sub_Value_Type.TEXT,7):""}
            {sub_value_group.sub_value_7.value}
     </p>
        <h5>
            {edit_mode?Field_Logic.get_sub_value_edit_link(sub_value_edit,Sub_Value_Type.TEXT,8):""}
            {sub_value_group.sub_value_8.value}
    </h5>
        <p>
            {edit_mode?Field_Logic.get_sub_value_edit_link(sub_value_edit,Sub_Value_Type.TEXT,9):""}
            {sub_value_group.sub_value_9.value}
    </p>
        </div>
        <div className="about-features">
        {edit_mode?Field_Logic.get_sub_value_edit_link(sub_value_edit,Sub_Value_Type.ITEMS,10):""}
    <ul className="list-one">
    {sub_value_group.sub_value_10.items.map((item) => (
                <li>
                <span>
                <ImageWithBasePath
                src={Image.get_url(item.image,Image_Format.ORIGINAL)}
                alt="img"
                />
                </span>
                {item.text}
                </li>
                ))}
    </ul>
    {edit_mode?Field_Logic.get_sub_value_edit_link(sub_value_edit,Sub_Value_Type.ITEMS,11):""}
    <ul className="list-two">
            {sub_value_group.sub_value_11.items.map((item) => (
                <li>
                <span>
                <ImageWithBasePath
                src={Image.get_url(item.image,Image_Format.ORIGINAL)}
                alt="img"
                />
                </span>
 {item.text}
                </li>
                ))}
    </ul>
        </div>
        </div>
        </div>
        </div>
        </div>
        </section>
        {/* /About Us */}
    {/* Why Choose Us */}
    <section className="why-choose-sec">
        <div className="container">
        <div className="about-us-header">
        <h2>
        {edit_mode?Field_Logic.get_sub_value_edit_link(sub_value_edit,Sub_Value_Type.TEXT,12):""}
    {sub_value_group.sub_value_12.value}

    </h2>
        <p>
        {edit_mode?Field_Logic.get_sub_value_edit_link(sub_value_edit,Sub_Value_Type.TEXT,13):""}
    {sub_value_group.sub_value_13.value}
    </p>
        </div>
       {edit_mode?Field_Logic.get_sub_value_edit_link(sub_value_edit,Sub_Value_Type.ITEMS,14):""}
        <div className="row">

 {sub_value_group.sub_value_14.items.map((item) => (
            <div className="col-lg-4">
            <div className="why-choose-card">
              <div className="card-icon">
                <ImageWithBasePath src={Image.get_url(item.image,Image_Format.ORIGINAL)} alt="img" />
              </div>
              <h4>{item.title}</h4>
              <p>
                {" "}
                {item.sub_note}
                </p>
            </div>
          </div>
                   ))}
               </div>
               </div>
        </section>
        {/* /Why Choose Us */}
    {/* Explore Popular Categories */}
    <section className="popular-category-sec">
        <div className="container">
        <div className="about-us-header">
        <h2>
        {edit_mode?Field_Logic.get_sub_value_edit_link(sub_value_edit,Sub_Value_Type.TEXT,15):""}
    {sub_value_group.sub_value_15.value}
    </h2>
        <p>
        {edit_mode?Field_Logic.get_sub_value_edit_link(sub_value_edit,Sub_Value_Type.TEXT,16):""}
    {sub_value_group.sub_value_16.value}
    </p>
        </div>
        <div className="row">
        <div className="col-md-12">
        <div className="popular-category-slider owl-carousel">
        <Slider {...popularCategorySlider}>
  {categorys.map((item) => (
              <div className="slider-cards">
        <div className="popular-cat-card">

        <Link to={all_routes.product_app+"?category="+item.title}>
        <div className="category-icon">
        <ImageWithBasePath
        src={Image.get_url(item.cover_image,Image_Format.ORIGINAL)}
        alt="img"
        />
        </div>
        <h4>
       {item.title}
        </h4>
        <span>{item.product_count} {" AppZ"}</span>
     </Link>
        </div>

        </div>
                  ))}
        </Slider>
        </div>
        </div>
        </div>
        </div>
        </section>
        {/* /Explore Popular Categories */}
    {/* What Our Client Say */}
    <section className="client-review-sec" hidden={true}>
        <div className="container">
        <div className="about-us-header">
        <h2>
        {edit_mode?Field_Logic.get_sub_value_edit_link(sub_value_edit,Sub_Value_Type.TEXT,18):""}
        {sub_value_group.sub_value_18.value}
    </h2>
        <p>
        {edit_mode?Field_Logic.get_sub_value_edit_link(sub_value_edit,Sub_Value_Type.TEXT,19):""}
        {sub_value_group.sub_value_19.value}
    </p>
        </div>
        <div className="row">
        <div className="col-md-12">
        <div className="review-slider owl-carousel">
        <Slider {...clientstay}>
        <div className="review-card">
        <span className="quotation-icon">
        <ImageWithBasePath src="/assets/img/icons/quotation-icon.svg" alt="img" />
        </span>
        <h4>
        {edit_mode?Field_Logic.get_sub_value_edit_link(sub_value_edit,Sub_Value_Type.TEXT,34):""}
        {sub_value_group.sub_value_34.value}
    </h4>
        <p>
        “Amazing design, easy to customize and a design quality
        superlative account on its cloud platform for the optimized
        performance. And we didn't on our original designs and
        Development.”
        </p>
        <div className="star-rate">
        <span>
        <i className="fa-solid fa-star filled" />
        <i className="fa-solid fa-star filled" />
        <i className="fa-solid fa-star filled" />
        <i className="fa-solid fa-star filled" />
        <i className="fa-solid fa-star filled" />
        </span>
        </div>
        <div className="review-user">
        <Link to="#">
        <ImageWithBasePath src="/assets/img/user/user-17.jpg" alt="img" />
        </Link>
        <h6>
        <Link to="#">Gloria Weber</Link>
        <span>United States</span>
        </h6>
        </div>
        </div>
        <div className="review-card">
        <span className="quotation-icon">
        <ImageWithBasePath src="/assets/img/icons/quotation-icon.svg" alt="img" />
        </span>
        <h4>Seamless Experience</h4>
        <p>
        “Communication with the service provider was smooth and
        efficient through the platform's messaging system. The built-in
        tools for file sharing ensuring a productive experience.”
        </p>
        <div className="star-rate">
        <span>
        <i className="fa-solid fa-star filled" />
        <i className="fa-solid fa-star filled" />
        <i className="fa-solid fa-star filled" />
        <i className="fa-solid fa-star filled" />
        <i className="fa-solid fa-star filled" />
        </span>
        </div>
        <div className="review-user">
        <Link to="#">
        <ImageWithBasePath src="/assets/img/user/user-18.jpg" alt="img" />
        </Link>
        <h6>
        <Link to="#">John Cramer</Link>
        <span>United States</span>
        </h6>
        </div>
        </div>
        <div className="review-card">
        <span className="quotation-icon">
        <ImageWithBasePath src="/assets/img/icons/quotation-icon.svg" alt="img" />
        </span>
        <h4>Great Work</h4>
        <p>
        “This service marketplace is a game-changer, delivering a
        polished and professional platform that exceeded our
        expectations and it saved us time and resources, allowing for a
        quick launch.”
        </p>
        <div className="star-rate">
        <span>
        <i className="fa-solid fa-star filled" />
        <i className="fa-solid fa-star filled" />
        <i className="fa-solid fa-star filled" />
        <i className="fa-solid fa-star filled" />
        <i className="fa-solid fa-star filled" />
        </span>
        </div>
        <div className="review-user">
        <Link to="#">
        <ImageWithBasePath src="/assets/img/user/user-19.jpg" alt="img" />
        </Link>
        <h6>
        <Link to="#">Mary Marquez</Link>
        <span>United States</span>
        </h6>
        </div>
        </div>
        <div className="review-card">
        <span className="quotation-icon">
        <ImageWithBasePath src="/assets/img/icons/quotation-icon.svg" alt="img" />
        </span>
        <h4>Great Work</h4>
        <p>
        “This service marketplace is a game-changer, delivering a
        polished and professional platform that exceeded our
        expectations and it saved us time and resources, allowing for a
        quick launch.”
        </p>
        <div className="star-rate">
        <span>
        <i className="fa-solid fa-star filled" />
        <i className="fa-solid fa-star filled" />
        <i className="fa-solid fa-star filled" />
        <i className="fa-solid fa-star filled" />
        <i className="fa-solid fa-star filled" />
        </span>
        </div>
        <div className="review-user">
        <Link to="#">
        <ImageWithBasePath src="/assets/img/user/user-16.jpg" alt="img" />
        </Link>
        <h6>
        <Link to="#">Joanne Parise</Link>
        <span>United States</span>
        </h6>
        </div>
        </div>
        </Slider>
        </div>
        </div>
        </div>
        </div>
        </section>
        {/* /What Our Client Say */}
    {/* Start As Seller */}
    <section className="start-seller-sec">
      <div className="container">
        <div className="row">
          <div className="col-lg-6 d-flex">
            <div className="seller-inner-img w-100">

               {edit_mode?Field_Logic.get_sub_value_edit_link(sub_value_edit,Sub_Value_Type.IMAGE,20):""}
    <ImageWithBasePath src={Image.get_url(sub_value_group.sub_value_20.value,Image_Format.ORIGINAL)} className="img-fluid" alt="IMG" />

            </div>
          </div>

          <div className="col-lg-6 d-flex">
            <div className="seller-info-content w-100">
              <div className="seller-head">
                <h3>
                {edit_mode?Field_Logic.get_sub_value_edit_link(sub_value_edit,Sub_Value_Type.TEXT,21):""}
                {sub_value_group.sub_value_21.value}
                </h3>
                <p>
                {edit_mode?Field_Logic.get_sub_value_edit_link(sub_value_edit,Sub_Value_Type.TEXT,22):""}
                {sub_value_group.sub_value_22.value}
                </p>
              </div>
              <div className="seller-feature-list d-flex w-100">
                <div className="sllers-list">
                {edit_mode?Field_Logic.get_sub_value_edit_link(sub_value_edit,Sub_Value_Type.ITEMS,23):""}
                  <ul>
                {sub_value_group.sub_value_23.items.map((item) => (
                    <li>
                      <span>
                        <i className="feather-check-square" />
<i className="fas fa-solid fa-dollar-sign"> </i>
                      </span>
                     {item.text}
                    </li>
                  ))}
                  </ul>
                  <Link to={'#'} className="btn btn-primary w-auto">
                {edit_mode?Field_Logic.get_sub_value_edit_link(sub_value_edit,Sub_Value_Type.TEXT,24):""}
                {sub_value_group.sub_value_24.value}
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
   {/* /Start As Seller */}
      <SubValue sub_value_edit={sub_value_edit} edit_mode={edit_mode} update_sub_value={update_sub_value}  />
 </>

        )
}

export default About
